import React from "react";
import useAssessmentPermissions from "@features/assessments-feature/hooks/useAssessmentPermissions";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import ScienceIcon from "@mui/icons-material/Science";
import TryIcon from "@mui/icons-material/Try";
import GradingIcon from "@mui/icons-material/Grading";


const researchLabs: string = "/labs";
const researchAssessments: string = "/assessments";
const researchRecommendations: string = "/recommendations";

export function useGetResearchNavItems() {
  const { hasPermission } = useClaims();
  const { data: programPermissions } = useAssessmentPermissions();

  const hasAssessmentsPermission = Object.values(programPermissions ?? {}).some(
    (permission) => hasPermission(permission),
  );
  const hasRoadmapsPermission = hasPermission(ShiOnePermission.roadmapsManage);

  return [
    {
      id: "assessments",
      type: "Link",
      displayName: "Assessments",
      visible: hasAssessmentsPermission,
      icon: <GradingIcon />,
      path: researchAssessments,
    },
    {
      id: "recommendations",
      type: "Link",
      displayName: "Recommendations",
      visible: hasRoadmapsPermission,
      icon: <TryIcon />,
      path: researchRecommendations,
    },
    {
      id: "labs",
      type: "Link",
      displayName: "Labs",
      visible: hasPermission(ShiOnePermission.labsRead),
      icon: <ScienceIcon />,
      path: researchLabs,
    },
  ];
}
